import Salgadas from "../Components/Receitas/Salgadas/Salgadas.jsx";

export default function ReceitasSalgadas() {
  return <Salgadas />;
}
